// extracted by mini-css-extract-plugin
module.exports = {"badge":"CheckInBadge_badge__2EjWx","subText":"CheckInBadge_subText__2Q_OA","icon":"CheckInBadge_icon__PFLvg","checkins":"CheckInBadge_checkins__1nZkl"};